import React from 'react';
import { Button } from 'antd';
import useCompanySwitch from '../hooks/useCompanySwitch';

const BroadcastDemoPage: React.FC = () => {
  const { switchCompany, isLoading } = useCompanySwitch();

  const handleSwitch = async () => {
    try {
      await switchCompany(1); // Example company id
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div className="p-4">
      <Button type="primary" onClick={handleSwitch} loading={isLoading}>
        Switch Company
      </Button>
    </div>
  );
};

export default BroadcastDemoPage;

